var render = function render(){var _vm=this,_c=_vm._self._c;return _c(_vm.element,{tag:"component",staticClass:"stream-components-text",class:[
      { 'stream-components-text--empty': _vm.empty },
      { 'stream-components-text--clamped': _vm.isClamped }
    ],style:({ '--max-lines': _vm.maxLines }),on:{"click":function($event){$event.stopPropagation();return _vm.$emit('click')},"mouseenter":function($event){return _vm.$emit('mouseenter')},"mouseleave":function($event){return _vm.$emit('mouseleave')}}},[(_vm.content)?_c('span',{domProps:{"innerHTML":_vm._s(_vm.content)}}):_vm._e(),_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }